export const URL_BASE_CONVENIENCIA = 'https://api-conveniencia.inceres.com.br/';
export const URL_BASE_CONVENIENCIA_STAG = 'https://stag-api-conveniencia.inceres.com.br';
export const DEFAULT_SYNC_DATE = '1900-01-01T00:00:00.000Z';
